<ion-searchbar
  #searchTerm
  class="search"
  (keydown.enter)="search(searchTerm)"
  placeholder="{{ placeholder }}"
></ion-searchbar>
